import React, { useState, useEffect } from "react";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TokenTable from "./tokenTable";

const AccessTokens = () => {

  const [settings, setSettings] = useState({
    tokenName:"",
    expiryDay:""  
  });

  const [tokens, setTokens] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {

    const fetchOrganizationDetails = async () => {

      setIsLoading(true)

      const token = sessionStorage.getItem('ASIToken');

      try {
        const response = await axios.get('api/v1/integrations/getAccessToken', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const orgDetails = response.data;

        console.log("orgDetails", orgDetails)


        setTokens(response.data.data)
        setIsLoading(false)
        
      } catch (error) {
        setIsLoading(false)
        console.error('Error fetching organization details:', error);
      }
    };

    fetchOrganizationDetails();

  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prevSettings => ({
      ...prevSettings,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = sessionStorage.getItem('ASIToken');

    try {

        console.log("settings", settings)

      const response = await axios.post('/api/v1/integrations/generate-access-token', settings, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      console.log('Settings saved successfully:', response.data);
      // Handle success (e.g., show a success message)

      toast.success("Access token Saved", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      window.location.reload();

    } catch (error) {
      console.error('Error saving settings:', error);
      // Handle error (e.g., show an error message)
    }
  };

  if (isLoading) {
    return (
      <div className="loading-spinner" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh'
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '5px solid #f3f3f3',
          borderTop: '5px solid #e50202',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="sast-scan-instructions" style={{ padding: 20 }}>
  <h4 className="darkText">New access token generate</h4>
  <hr />
  <form
    onSubmit={handleSubmit}
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-end',
      gap: 20,
      marginTop: 20,
    }}
  >
    <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 250px' }}>
      <label>
        Token name<span style={{ color: 'red' }}>*</span>
      </label>
      <input
        type="text"
        name="tokenName"
        placeholder="Token name"
        value={settings.tokenName}
        style={{ color: '#000', padding: 8 }}
        onChange={handleChange}
        required
      />
    </div>

    <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 250px' }}>
      <label>
        Expire Days<span style={{ color: 'red' }}>*</span>
      </label>
      <select
        name="expiryDay"
        value={settings.expiryDay
        }
        onChange={handleChange}
        required
        style={{ color: '#000', padding: 8 }}
      >
        <option value="">Select duration</option>
        <option value="30">30 days</option>
        <option value="60">60 days</option>
        <option value="90">90 days</option>
      </select>
    </div>

    <button
      className="primaryButton"
      type="submit"
      style={{
        background: '#e50202',
        borderColor: '#e50202',
        borderWidth: 0,
        color: '#fff',
        padding: 10,
        borderRadius: 10,
        height: 42,
        flex: '1 1 150px',
        minWidth: 150,
      }}
    >
      Generate token
    </button>
  </form>

  <hr/>

  <TokenTable tokens={tokens} />
</div>

  );
};

export default AccessTokens;